import { EmptyPage } from '../empty-page/EmptyPage';

export const Employees = () => {
  return <EmptyPage />;
};
